const Show = () => {
  return (
    <svg version="1.1" width="24" height="24"  viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="  M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z" fill="none" id="XMLID_10_" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
      <circle cx="16" cy="16" fill="none" r="5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
    </svg>
  );
};

export default Show;